import { render, staticRenderFns } from "./goodsRefundAudit.vue?vue&type=template&id=f5189610&scoped=true"
import script from "./goodsRefundAudit.vue?vue&type=script&lang=ts"
export * from "./goodsRefundAudit.vue?vue&type=script&lang=ts"
import style0 from "./goodsRefundAudit.vue?vue&type=style&index=0&id=f5189610&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5189610",
  null
  
)

export default component.exports